import { useState } from "react";
import { useTranslation } from "react-i18next";

import type { Project } from "../../types";
import {
  changeProject,
  ProjectActionsDialog,
  useProjectManagementAccess,
} from "../ProjectActionsDialog";
import { Button } from "../ui/button";

export function ArchivedProjectActions({
  project,
  onChanged,
}: {
  project: Project;
  onChanged: () => void;
}) {
  const { t } = useTranslation();
  const { allowed } = useProjectManagementAccess(project.createdBy);
  const [deleting, setDeleting] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const restore = async () => {
    if (!allowed || busy) return;
    setBusy(true);
    try {
      await changeProject(project, "unarchive");
      onChanged();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : t("common/anErrorOccurred_gd0s0s"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex flex-wrap items-center gap-2">
      {!allowed && (
        <span className="text-xs text-muted-foreground">
          {t("common/onlyTheProjectOwner_rfeqph", {
            name: project.createdBy?.name ?? project.createdBy?.userId,
          })}
        </span>
      )}
      {error && <span role="alert">{error}</span>}
      <Button
        size="sm"
        variant="outline"
        disabled={!allowed || busy}
        onClick={() => void restore()}
      >
        {t("settings/restore_cpc7er")}
      </Button>
      <Button
        size="sm"
        variant="destructive"
        disabled={!allowed || busy}
        onClick={() => setDeleting(true)}
      >
        {t("common/delete_ivk488")}
      </Button>
      {deleting && (
        <ProjectActionsDialog
          project={project}
          archived
          onClose={() => setDeleting(false)}
          onChanged={onChanged}
        />
      )}
    </div>
  );
}
